// TSS vite/03 §"Query keys convention". Tuplas, entidad primero.
// Dominio SG (Software Ganadero): navegador de vacas físicas (admin-sg.md).

export const sgKeys = {
    all:       ['sg'],
    cows:      (filters) => ['sg', 'cows', filters],
    cow:       (cowId)   => ['sg', 'cow', cowId],
    cowEvents: (cowId, feature, filters) => ['sg', 'cow', cowId, 'events', feature, filters],
};
